import { USER_ENDPOINTS } from "./endpoints";
import type { GetProfileResponse } from "./types";
import { apiGetWithData } from "../shared";

export default async function getProfile(): Promise<GetProfileResponse["data"]> {
  return apiGetWithData<GetProfileResponse["data"]>(USER_ENDPOINTS.PROFILE);
}
